document.addEventListener("DOMContentLoaded", () => {
  const MAX_ITEMS = 4;

  const subscribeTitleEl = document.querySelector(".subscribe_title");
  const SAVE_PERCENT = Number(subscribeTitleEl?.dataset.save) || 0;
  const DISCOUNT_RATE = SAVE_PERCENT / 100;

  let bundleItems = [];

  const gridItems = document.querySelectorAll(".byob_grid_item");
  const itemCountEl = document.querySelector(".byob_item_count");
  const itemCountMB = document.querySelector(".mb_item_count");
  const oneTimePriceEl = document.querySelector(".one_time_btn .price");
  const subSavePriceEl = document.querySelector(".sub_btn .save_price");
  const subOriginalPriceEl = document.querySelector(".sub_btn .original_price");
  const byobAtcBtn = document.querySelector(".atc_btn");
  const subscribeSelect = document.querySelector(".sub_btn select");

  if (!gridItems.length) return;

  const formatMoney = cents => `$${(cents / 100).toFixed(2)}`;

  const updateCounter = () => {
    if (itemCountEl) {
      itemCountEl.textContent = `(${bundleItems.length}/${MAX_ITEMS})`;
    }

    if (itemCountMB) {
      itemCountMB.textContent = `(${bundleItems.length}/${MAX_ITEMS})`;
    }
  };

  const updatePrices = () => {
    const total = bundleItems.reduce((sum, item) => sum + item.price, 0);
    const discounted = Math.round(total * (1 - DISCOUNT_RATE));

    oneTimePriceEl && (oneTimePriceEl.textContent = formatMoney(total));
    subSavePriceEl && (subSavePriceEl.textContent = formatMoney(discounted));
    subOriginalPriceEl && (subOriginalPriceEl.textContent = formatMoney(total));
  };

  const getNextEmptySlot = () =>
    [...gridItems].find(item => !item.classList.contains("bundle_product"));

  const refreshQuickAddButtons = () => {
    const isFull = bundleItems.length >= MAX_ITEMS;
    document.querySelectorAll(".product_item").forEach(card =>
      card.classList.toggle("disabled", isFull)
    );
    if (byobAtcBtn) {
      if (isFull) {
        byobAtcBtn.removeAttribute("disabled");
        byobAtcBtn.classList.remove("button_disable");
      } else {
        byobAtcBtn.setAttribute("disabled", "disabled");
        byobAtcBtn.classList.add("button_disable");
      }
    }
  };


  const getSellingPlansFromModal = modal => {
    if (!modal) {
      console.log("No modal provided");
      return null;
    }

    const plansDiv = modal.querySelector(".byob-selling-plans-data");
    
    if (!plansDiv) {
      // console.log("No .byob-selling-plans-data div found in modal");
      return null;
    }

    const plansData = plansDiv.dataset.plans;
    
    if (!plansData) {
      // console.log("No data-plans attribute found");
      return null;
    }

    try {
      const parsed = JSON.parse(plansData);
      // console.log("✅ Selling plans found:", parsed);
      return parsed;
    } catch (e) {
      // console.error("❌ Error parsing selling plans:", e);
      return null;
    }
  };

  const addToGrid = ({ variantId, image, sellingPlans = null }) => {
    const slot = getNextEmptySlot();
    if (!slot || !variantId) return;

    slot.classList.add("bundle_product");
    slot.classList.remove("byob_grid_focus");
    slot.dataset.variantId = variantId;
    const hasSellingPlans = sellingPlans && sellingPlans.length > 0;
    // console.log(`Adding to grid - Variant: ${variantId}, Has Selling Plans: ${hasSellingPlans}`);
    if (!hasSellingPlans) {
      slot.classList.add("one_time_product");
    } else {
      slot.dataset.sellingPlans = JSON.stringify(sellingPlans);
    }

    slot.innerHTML = `
      <img src="${image}" alt="" loading="lazy">
      <input type="hidden" name="bundle_items[]" value="${variantId}">
      ${hasSellingPlans ? `<input type="hidden" class="selling-plans-data" value='${JSON.stringify(sellingPlans)}'>` : ''}
      <span class="remove_icon active">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
          <path d="M7.5 0H5.83333V5.25H0V6.75H5.83333V12H7.5V6.75H13.3333V5.25H7.5V0Z" fill="#fff"/>
        </svg>
      </span>
    `;
  };

  const resetSlot = slot => {
    slot.classList.add("byob_grid_focus");
    slot.classList.remove("bundle_product", "one_time_product");
    delete slot.dataset.variantId;
    delete slot.dataset.sellingPlans;
    slot.innerHTML = `<span class="add_icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M7.5 0H5.83333V5.25H0V6.75H5.83333V12H7.5V6.75H13.3333V5.25H7.5V0Z" fill="#172F56"/></svg></span>`;
  };

  document.body.addEventListener("click", e => {
    const removeBtn = e.target.closest(".byob_grid_item .remove_icon.active");
    if (removeBtn) {
      const slot = removeBtn.closest(".byob_grid_item");
      const variantId = slot?.dataset.variantId;

      if (variantId) {
        const index = bundleItems.findIndex(
          item => String(item.variantId) === String(variantId)
        );
        if (index > -1) {
          bundleItems.splice(index, 1);
        }
      }
      resetSlot(slot);
      updateCounter();
      updatePrices();
      refreshQuickAddButtons();
      return;
    }

    const submitBtn = e.target.closest(".byob_modal .product-form__submit");
    if (!submitBtn) return;

    e.preventDefault();
    if (bundleItems.length >= MAX_ITEMS) return;

    const modal = submitBtn.closest(".byob_modal");
    if (!modal) return;

    const sellingPlansArray = getSellingPlansFromModal(modal);

    const variantJsonEl = modal.querySelector("script[data-selected-variant]");
    let variantData = null;

    if (variantJsonEl) {
      try {
        variantData = JSON.parse(variantJsonEl.textContent);
      } catch (_) {}
    }

    const variantId =
      variantData?.id ||
      modal.querySelector('input[name="id"]')?.value ||
      modal.querySelector(".product-variant-id")?.value ||
      submitBtn.dataset.variantId;

    if (!variantId) {
      console.warn("BYOB: Variant ID not found");
      return;
    }

     // console.log("Variant ID:", variantId);

    let price =
      variantData?.price ||
      Math.round(
        parseFloat(
          modal.querySelector(".price-item--regular, .price-item--sale")
            ?.textContent.replace(/[^0-9.]/g, "")
        ) * 100
      ) ||
      0;

    if (!price) return;

    const image =
      modal.querySelector(".product__media img")?.src ||
      submitBtn.closest(".product_item")?.querySelector("img")?.src ||
      "";

    const quantity = Math.max(
      parseInt(modal.querySelector('input[name="quantity"]')?.value || 1, 10),
      1
    );

    let variantSellingPlans = null;
    
    if (sellingPlansArray && sellingPlansArray.length > 0) {
      variantSellingPlans = sellingPlansArray.filter(
        plan => String(plan.variant_id) === String(variantId)
      );
      
     // console.log("Filtered selling plans for variant:", variantSellingPlans);
      
      if (variantSellingPlans.length === 0) {
        variantSellingPlans = null;
      }
    } else {
      // console.log("⚠️ No selling plans available for this product - will be one-time only");
    }

    for (let i = 0; i < quantity; i++) {
      if (bundleItems.length >= MAX_ITEMS) break;
      bundleItems.push({ variantId, price });
      addToGrid({
        variantId,
        image,
        sellingPlans: variantSellingPlans
      });
    }

    updateCounter();
    updatePrices();
    refreshQuickAddButtons();
    modal.querySelector(".quick-add-modal__toggle")?.click();
    document.body.classList.remove("overflow-hidden");
  });
});



const getBundleItems = () =>
  [...document.querySelectorAll(".byob_grid_item.bundle_product")];

const getOneTimeIndexes = items =>
  items
    .map((item, i) =>
      item.classList.contains("one_time_product") ? i + 1 : null
    )
    .filter(Boolean);

const getVariantCounts = items => {
  const map = {};
  items.forEach(item => {
    const id = item.dataset.variantId;
    map[id] = (map[id] || 0) + 1;
  });
  return Object.values(map);
};

const getSubscriptionPercent = items => {
  const counts = getVariantCounts(items);

  if (counts.length === 1) return 3;
  if (counts.includes(3)) return 3;
  if (counts.includes(2)) return 3;
  if (counts.length === 4) return 3;

  return 0;
};

const getSelectedDeliveryOption = () =>
  document.querySelector(".sub_btn select")?.value;

const getSellingPlanIdForItem = (item, selectedOptionText) => {
  let sellingPlansJson = item.dataset.sellingPlans;
  
  if (!sellingPlansJson) {
    const hiddenInput = item.querySelector(".selling-plans-data");
    if (hiddenInput) {
      sellingPlansJson = hiddenInput.value;
    }
  }
  
  if (!sellingPlansJson) {
    // console.warn("⚠️ No selling plans found for item:", item.dataset.variantId);
    return null;
  }

  try {
    const plans = JSON.parse(sellingPlansJson);
    
    // console.log("📦 Item Variant ID:", item.dataset.variantId);
    // console.log("📋 Available Plans:", plans);
    // console.log("🎯 Selected Option Text:", selectedOptionText);

    const matchedPlan = plans.find(plan => {
      const planNameLower = plan.name.toLowerCase();
      const optionTextLower = selectedOptionText.toLowerCase();
      const planWords = planNameLower.split(' ').slice(0, 3).join(' ');
      return optionTextLower.includes(planWords) || planNameLower.includes(optionTextLower);
    });

    if (matchedPlan) {
      return matchedPlan.selling_plan_id;
    } else {
      // console.warn("❌ No matching plan found for:", selectedOptionText);
      return null;
    }
  } catch (e) {
    // console.error("❌ Error parsing selling plans:", e);
    return null;
  }
};


document.querySelector(".sub_btn select")?.addEventListener("change", e => {
  const selectedOptionText = e.target.options[e.target.selectedIndex].text;
  const items = getBundleItems();
  if (items.length !== MAX_ITEMS) {
   // console.warn("⚠️ Not enough items in bundle");
    return;
  }
  const isSubscriptionChecked = document.querySelector(".sub_btn input[type='radio']")?.checked;
  
  if (!isSubscriptionChecked) {
    // console.log("ℹ️ Subscription not selected, skipping validation");
    return;
  }

  let allValid = true;

  items.forEach((item, index) => {
    const variantId = item.dataset.variantId;
    const isOneTime = item.classList.contains("one_time_product");
    
    
    if (isOneTime) {
      // console.warn(`⚠️ Product ${index + 1} is one-time only (no selling plans div found)`);
      allValid = false;
      return;
    }
    
    const sellingPlanId = getSellingPlanIdForItem(item, selectedOptionText);
    console.log("Selling Plan ID:", sellingPlanId);
    
    if (!sellingPlanId) {
      // alert(`⚠️ Product at position ${index + 1} (Variant: ${variantId}) does not have a matching selling plan for "${selectedOptionText}"`);
      allValid = false;
    }
  });

  if (allValid) {
    // console.log("✅ All products validated successfully!");
  }

});

document
  .querySelector(".sub_btn input[type='radio']")
  ?.addEventListener("change", e => {
    if (!e.target.checked) return;

    const items = getBundleItems();
    if (items.length !== 4) {
      const itemsLeft = 4 - items.length;
      alert(
        `Please add ${itemsLeft} more product${itemsLeft > 1 ? "s" : ""} to enable subscription.`
      );
      e.target.checked = false;
      document.querySelector(".one_time_btn input").checked = true;
      return;
    }

    const invalidIndexes = getOneTimeIndexes(items);

    if (invalidIndexes.length) {
      alert(
        `Subscription not available.\n` +
          `Product(s) at position ${invalidIndexes.join(", ")} ` +
          `do not support subscription.`
      );
      e.target.checked = false;
      document.querySelector(".one_time_btn input").checked = true;
      return;
    }

    const percent = getSubscriptionPercent(items);

    document.querySelector(".sub_btn h5").textContent =
      `Subscribe & Save ${percent}%`;

    document.querySelector(".sub_btn ul li span").textContent =
      `${percent}% OFF future orders`;
  });

document.querySelector(".atc_btn")?.addEventListener("click", (e) => {
  const items = getBundleItems();
  const isSubscription =
    document.querySelector(".sub_btn input[type='radio']")?.checked;
  e.currentTarget.querySelector('.loading__spinner')?.classList.remove('hidden');

  // ONE-TIME
  if (!isSubscription) {
    const payload = {
      items: items.map(item => ({
        id: Number(item.dataset.variantId),
        quantity: 1
      }))
    };
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        console.log('Success:', data);
        fetch('/')
            .then(res => res.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');

                const cartDrawer = document.querySelector('cart-drawer');
                const cartCount = document.querySelector('#cart-icon-bubble');
                const atcBTN = document.querySelector('.byob_atc .loading__spinner');
                cartDrawer.innerHTML = doc.querySelector('cart-drawer').innerHTML;
                cartDrawer.classList.remove('is-empty');
                cartDrawer.classList.add('active');
                cartCount.innerHTML = doc.querySelector('#cart-icon-bubble').innerHTML;
                document.body.classList.add('overflow-hidden');
                atcBTN?.classList.add('hidden');
            });
      })
      .catch(err => {
        alert("Error adding to cart. Please try again.");
      });

    return;
  }

  // SUBSCRIPTION
  const selectElement = document.querySelector(".sub_btn select");
  const selectedOptionText = selectElement?.options[selectElement.selectedIndex]?.text;
  if (!selectedOptionText) {
    alert("Please select a delivery option.");
    return;
  }

  const payload = items.map((item, index) => {
    const sellingPlanId = getSellingPlanIdForItem(item, selectedOptionText);
    return {
      id: Number(item.dataset.variantId),
      quantity: 1,
      selling_plan: sellingPlanId
    };
  });

  console.log("Subscription Payload:", payload);

  if (payload.some(p => !p.selling_plan)) {
    alert("Subscription plan not found for selected delivery option.");
    return;
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: payload })
  })
    .then(res => res.json())
    .then(data => {
        console.log('Success:', data);
        fetch('/')
            .then(res => res.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');

                const cartDrawer = document.querySelector('cart-drawer');
                const cartCount = document.querySelector('#cart-icon-bubble');
                const atcBTN = document.querySelector('.byob_atc .loading__spinner');
                cartDrawer.innerHTML = doc.querySelector('cart-drawer').innerHTML;
                cartDrawer.classList.remove('is-empty');
                cartDrawer.classList.add('active');
                cartCount.innerHTML = doc.querySelector('#cart-icon-bubble').innerHTML;
                document.body.classList.add('overflow-hidden');
                atcBTN?.classList.add('hidden');
               
            });
    })
    .catch(err => {
      alert("Error adding subscription to cart. Please try again.");
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const byobBlock = document.querySelector(".byob_detail");
  const byobHeader = byobBlock.querySelector(".mb_header");
  const quotifyBtn = document.querySelector(".quotify-sticky-cart-btn");

  if (!byobHeader || !byobBlock || !quotifyBtn) return;

  byobHeader.addEventListener("click", () => {
    byobBlock.classList.toggle("mb_detail_open");
    byobHeader.classList.toggle("is_active");

      if (byobBlock.classList.contains("mb_detail_open")) {
        quotifyBtn.style.display = "none";
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
        quotifyBtn.style.display = "";
      }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const byobItems = document.querySelectorAll(".byob_grid_item");
  const productItems = document.querySelectorAll(".product_item");
  if (!byobItems.length || !productItems.length) return;
  byobItems.forEach(item => {
    item.addEventListener("click", () => {
      if (!item.classList.contains("byob_grid_focus")) return;
      if (item.querySelector(".one_time_product")) return;
      productItems.forEach(product => {
        product.classList.add("byob_item_focus");
      });
      setTimeout(() => {
        productItems.forEach(product => {
          product.classList.remove("byob_item_focus");
        });
      }, 2000);
    });
  });
});
